export const isFirefoxStrictModeEnabled = () => {
  //browser setting that blocks NotifyMe subscription
  return navigator?.doNotTrack === '1';
};
